<script lang="ts">
    import Router, { link } from 'svelte-spa-router'
    import { propsWrapper } from '../../../core/router/helper'
    import type ServiceProvider from '../services/service.provider'
    import type DataProvider from '../services/data.provider'
    import type { ICategory, ISubCategory } from '../interfaces/category.interface'
    import { slugify } from '../../../core/helpers/string.helper'
    import { getIdFromSlug } from '../../../core/helpers/url.helper'
    import type { IService } from '../interfaces/service.interface'
    import { scrollToTop } from '../../../core/helpers/window.helper'
    import AppError from './Error.svelte'

    export let serviceProvider: ServiceProvider
    export let dataProvider: DataProvider
    export let params: { categoryId: string }

    let processingSubCategories: boolean = false;
    let errorSubCategories: boolean = false;
    let subCategories: ISubCategory[] = []

    let processingServices: boolean = false;
    let errorServices: boolean = false;
    let services: IService[] = []

    let selectedSubCategoryId: string = null
    let category: ICategory = null

    const props = { serviceProvider, dataProvider }
    const routes = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        '/:subCategoryId': propsWrapper(() => import('./Service.svelte'), props),
    }

    $: categoryId = getIdFromSlug(params.categoryId)
    $: dataProvider.selectedCategoryId = String(categoryId)
    $: serviceProvider.categoryService.loadSubCategories(String(categoryId))
    $: serviceProvider.categoryService.prepareCategoryById(categoryId)
    $: serviceProvider.serviceService.loadServices(String(categoryId))

    dataProvider.selectedSubCategoryIdSubs.subscribe((status) => selectedSubCategoryId = status)
    serviceProvider.categoryService.categorySubs.subscribe((data) => category = data)
    
    // SUBCATEGORIES

    serviceProvider.categoryService.processingSubCategoriesSubs.subscribe((status) => (processingSubCategories = status))
    serviceProvider.categoryService.errorSubCategoriesSubs.subscribe((status) => (errorSubCategories = status))
    serviceProvider.categoryService.subCategoriesSubs.subscribe((data) => {
        subCategories = data
        // @ts-ignore
        setTimeout(() => removeClickFocus(), 100)
        scrollToTop()
    })

    // SERVICES

    serviceProvider.serviceService.processingServicesSubs.subscribe((status) => (processingServices = status))
    serviceProvider.serviceService.errorServicesSubs.subscribe((status) => (errorServices = status))
    serviceProvider.serviceService.servicesSubs.subscribe((data) => {
        services = data
        // @ts-ignore
        setTimeout(() => removeClickFocus(), 100)
    })
</script>

<div class="bno-category-list__col bno-category-list__subcategories">
    <div class="bno-category-list__col-inner is-active">
        <div class="bno-category-list__content">
            {#if category}
                <h2>
                    <a href="/"
                       use:link
                       class="bno-category-list__back-btn"
                       aria-label="Vrátit se zpět"
                       role="button"
                       tabindex="0"
                       />
                    {category.nazev}
                </h2>
            {/if}
        </div>
        {#if processingSubCategories || processingServices}
            <!-- <div class="bno-category-list__content">
                <p>Načítám...</p>
            </div> -->
        {:else if errorSubCategories || errorServices}
            <div class="bno-category-list__content">
                <AppError />
            </div>
        {:else}
            <ul class="bno-category-list__nav">
                {#each subCategories as subCategory}
                    <li class="bno-category-list__nav-item">
                        <a
                            href="/{params.categoryId}/{subCategory.id}-{slugify(subCategory.nazev)}"
                            title="{subCategory.nazev}"
                            aria-label="{subCategory.nazev}"
                            class:is-active={selectedSubCategoryId == subCategory.id}
                            class="bno-category-list__nav-link has-arrow"
                            use:link>
                            <h4>
                                <span class="bno-link">{subCategory.nazev}</span>
                            </h4>
                        </a>
                    </li>
                {/each}
                {#each services as service}
                    <li class="bno-category-list__nav-item">
                        <a
                            href="{service.slug}"
                            title="{service.nazev}"
                            aria-label="{service.nazev}"
                            class="bno-category-list__nav-link">
                            <h4>
                                <span class="bno-link">{service.nazev}</span>
                            </h4>
                        </a>
                    </li>
                {/each}
            </ul>
        {/if}
    </div>
</div>
{#if subCategories.length}
    <Router {routes} prefix={'/' + params.categoryId}/>
{/if}
